import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Games from "@/pages/Games";
import ForgeAdmin from "@/pages/ForgeAdmin";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Showcase from "@/pages/Showcase";
import Artists from "@/pages/Artists";
import ArtistDetail from "@/pages/ArtistDetail";
import Philanthropy from "@/pages/Philanthropy";
import WhatWeCollapse from "@/pages/WhatWeCollapse";
import Reel from "@/pages/Reel";
import SampleWebsite from "@/pages/SampleWebsite";
import ScoutsWindow from "@/pages/ScoutsWindow";
import { About, Mission, WhatWeDo, Terms, Privacy, Legal, Contact, Billion } from "@/pages/StudioPages";
import { OrderReturn, OrderReceipt } from "@/pages/Order";
import BugHunterWall from "@/pages/BugHunterWall";
import NotFound from "@/pages/NotFound";
import GrainOverlay from "@/components/GrainOverlay";
import ScrollToTop from "@/components/ScrollToTop";
import { Navigate } from "react-router-dom";

function App() {
  return (
    <div className="App bg-[#050505] text-[#ededed] min-h-screen">
      <GrainOverlay />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/games" element={<Games />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:slug" element={<ProductDetail />} />
          {/* Legacy slug redirects — publishing + ghostwriting merged into /products/books */}
          <Route path="/products/publishing" element={<Navigate to="/products/books" replace />} />
          <Route path="/products/ghostwriting" element={<Navigate to="/products/books" replace />} />
          {/* eCourses merged into pitch-deck (2026-08-29 Founder plain-ink) */}
          <Route path="/products/ecourses" element={<Navigate to="/products/pitch-deck" replace />} />
          <Route path="/what-we-collapse" element={<WhatWeCollapse />} />
          <Route path="/reel" element={<Reel />} />
          <Route path="/showcase" element={<Showcase />} />
          <Route path="/artists" element={<Artists />} />
          <Route path="/artists/:slug" element={<ArtistDetail />} />
          <Route path="/philanthropy" element={<Philanthropy />} />
          <Route path="/samples/website" element={<SampleWebsite />} />
          <Route path="/scouts" element={<ScoutsWindow />} />
          {/* Orders / receipts */}
          <Route path="/orders/return" element={<OrderReturn />} />
          <Route path="/orders/:orderId" element={<OrderReceipt />} />
          {/* Studio pages — now surfaced in nav under the Studio dropdown */}
          <Route path="/about" element={<About />} />
          <Route path="/mission" element={<Mission />} />
          <Route path="/what-we-do" element={<WhatWeDo />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/billion" element={<Billion />} />
          <Route path="/bug-hunter" element={<BugHunterWall />} />
          <Route path="/forge-admin" element={<ForgeAdmin />} />
          {/* 404 fallback — catches /docs, /openapi.json, and anything else */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#141417",
            border: "1px solid #27272a",
            color: "#ededed",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
